__turbopack_context__.v({
  "body": "_6b7aeW_body",
  "caption": "_6b7aeW_caption",
  "card": "_6b7aeW_card",
  "cardBody": "_6b7aeW_cardBody",
  "cardTitle": "_6b7aeW_cardTitle",
  "cards": "_6b7aeW_cards",
  "content": "_6b7aeW_content",
  "eyebrow": "_6b7aeW_eyebrow",
  "glass": "_6b7aeW_glass",
  "intro": "_6b7aeW_intro",
  "partnerLogo": "_6b7aeW_partnerLogo",
  "photo": "_6b7aeW_photo",
  "plate": "_6b7aeW_plate",
  "poweredBy": "_6b7aeW_poweredBy",
  "poweredByLabel": "_6b7aeW_poweredByLabel",
  "section": "_6b7aeW_section",
  "tint": "_6b7aeW_tint",
});
